/**
 * Приводит значение с провода к массиву.
 *
 * ЗАЧЕМ. Во фронте 75 раз встречается приём `const { data: items = [] } = useQuery(...)`.
 * Дефолт в деструктуризации срабатывает ТОЛЬКО на `undefined`; JSON-`null` проходит
 * насквозь, и следующий же `items.map(...)` роняет экран целиком —
 * `TypeError: … .map is not a function`, белый лист без единого слова. Такое падение
 * наблюдалось на списке абонентов 2026-09-02 (`h.map is not a function`).
 *
 * ПОЧЕМУ НЕ НОРМАЛИЗУЕМ В ПЕРЕХВАТЧИКЕ КЛИЕНТА. Соблазн — пройти тело ответа и заменить
 * все `null` на `[]`. Это сломало бы обнуляемые СКАЛЯРЫ: `date_connect: null` означает
 * «даты нет», а не «пустой список», и превратив его в `[]`, мы получили бы дефект хуже
 * исходного — тихий и повсеместный. Приведение к массиву осмысленно только там, где
 * потребитель ждёт массив, то есть на месте чтения.
 *
 * ПОЧЕМУ НЕ `?? []`. `??` тоже покрывает `null`, но молчит о намерении и не ловит третий
 * реальный случай: сервер (или перехватчик, отдавший тело ошибки) прислал ОБЪЕКТ вместо
 * массива. `Array.isArray` покрывает все три: `undefined`, `null`, не-массив.
 */
export function toArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
